import { useTranslate } from "@similarweb/i18n-provider";
import { OnOffSwitch, OnOffSwitchSize } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import extensionManagementTrackingService from "app/pages/sales-intelligence/modules/extension-management/tracking/trackingService";

import { FLOATING_ICON_ROW } from "../../constants/extensionSettingsConfig";
import type { ExtensionSettings } from "../../types/types";
import { SettingsSectionTitle } from "../SettingsSectionTitle/SettingsSectionTitle";

import { FloatingIconPreview } from "./FloatingIconPreview";

type FloatingIconSectionProps = {
    settings: ExtensionSettings;
    onToggle: () => void;
};

export const FloatingIconSection = ({ settings, onToggle }: FloatingIconSectionProps) => {
    const { translate } = useTranslate();
    const isSelected = settings.showFloatingBadge;

    const handleToggle = () => {
        extensionManagementTrackingService.trackSettingsToggle("showFloatingBadge", isSelected);
        onToggle();
    };

    return (
        <Stack data-automation="sales-intelligence-extension-floating-icon">
            <Flex
                alignItems="center"
                justifyContent="space-between"
            >
                <SettingsSectionTitle
                    title={translate(FLOATING_ICON_ROW.titleKey)}
                    description={translate(FLOATING_ICON_ROW.descriptionKey)}
                    dataAutomation="sales-intelligence-extension-floating-icon-title"
                />
                <Flex data-automation="sales-intelligence-extension-floating-icon-toggle">
                    <OnOffSwitch
                        size={OnOffSwitchSize.medium}
                        isSelected={isSelected}
                        onClick={handleToggle}
                    />
                </Flex>
            </Flex>
            <FloatingIconPreview isSelected={isSelected} />
        </Stack>
    );
};
